export default {
  prevText: '上一页',
  nextText: '下一页'
}



// WEBPACK FOOTER //
// ./src/components/pagination/locale/zh_CN.js